export default "__VITE_ASSET__w8EOuU0Y__"